var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-12" }, [
    _vm.newsfeeds.length > 0
      ? _c(
          "div",
          { staticClass: "row match-height" },
          _vm._l(_vm.newsfeeds, function (post, index) {
            return _c(
              "div",
              {
                key: post.id,
                class:
                  _vm.newsfeeds.length === 1
                    ? "col-12 col-md-12"
                    : "col-12 col-md-6",
              },
              [
                _c("schedule-post-display", {
                  attrs: { data: post },
                  on: {
                    deleted: function ($event) {
                      return _vm.remove(index)
                    },
                  },
                }),
              ],
              1
            )
          }),
          0
        )
      : _c("div", [
          _c("div", { staticClass: "card bg-outline-gray ml-1" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("h4", { staticClass: "card-title gray" }, [
                _vm._v(_vm._s(_vm.__("post.no_scheduled_posts"))),
              ]),
              _vm._v(" "),
              _vm._m(0),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("span", { staticClass: "gray" }, [
                _vm._v(_vm._s(_vm.__("post.form.paragraph.no_scheduled_post"))),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("a", { attrs: { href: "/member/help" } }, [
                  _c("button", { staticClass: "btn btn-outline-light mt-1" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.__("globals.menu_help")) +
                        "\n                        "
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _vm._m(1),
            ]),
          ]),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "heading-elements", attrs: { "data-action": "close" } },
      [_c("i", { staticClass: "feather icon-x" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ml-auto" }, [
      _c("img", {
        staticStyle: { float: "right", "margin-top": "-40px" },
        attrs: { src: "/images/annie.png", width: "50px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }